import { usePosModeActions } from '@/features/pos/contexts/PosMode'
import { useAppDispatch } from '@/hooks/redux'
import { clearSelectedOrderUuid } from '@/redux/reducers/orders'
import { Stack, useFocusEffect } from 'expo-router'
import { FC, useCallback } from 'react'

const Layout: FC = () => {
    const dispatch = useAppDispatch()
    const { setPos } = usePosModeActions()

    useFocusEffect(
        useCallback(() => {
            setPos()

            return () => {
                dispatch(clearSelectedOrderUuid())
            }
        }, [setPos, dispatch])
    )

    return <Stack screenOptions={{ headerShown: false }} />
}

export default Layout
